var map = {
	"./arrow-down-accent.svg": 5099,
	"./bg-pony.svg": 1422,
	"./bg.svg": 1701,
	"./icon-btn-star.svg": 8796,
	"./icon-burger-close.svg": 4223,
	"./icon-burger-open.svg": 4029,
	"./icon-star-accent.svg": 8116,
	"./icon-star-blue.svg": 847,
	"./icon-star-green.svg": 9858,
	"./icon-star-yellow.svg": 7202,
	"./logo-vertical.svg": 686,
	"./logo.svg": 3190,
	"./pony.svg": 3365,
	"./qr.svg": 4301,
	"./social-1.svg": 3196,
	"./social-2.svg": 3799,
	"./social-3.svg": 1589,
	"./social-4.svg": 9100,
	"./social-5.svg": 445,
	"./social-6.svg": 3402,
	"./social-7.svg": 9824,
	"./social-8.svg": 135,
	"./star-white.svg": 251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7254;